/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React, { useState, useMemo, useEffect } from 'react';
import dayjs from 'dayjs';
import SinglePanel from './SinglePanel.js';
import useConfig from '../../hooks/useConfig.js';
import { Button } from '../../button/index.js';
import { useTimePickerTextConfig } from '../hooks/useTimePickerTextConfig.js';
import { DEFAULT_FORMAT, DEFAULT_STEPS } from '../../_common/js/time-picker/const.js';
import '../../_chunks/dep-2acfafca.js';
import 'classnames';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_util/noop.js';
import '../../_common/js/time-picker/utils.js';
import '../../hooks/useDebounce.js';
import '../../_chunks/dep-01ce608f.js';
import '../../_util/usePersistFn.js';
import '../../hooks/usePropsRef.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../button/Button.js';
import '../../_chunks/dep-92728dc5.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_util/easing.js';
import '../../loading/index.js';
import '../../loading/Loading.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../button/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../button/style/css.js';
import '../../button/type.js';
import '../../locale/LocalReceiver.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TimePickerPanel = function TimePickerPanel(props) {
  var _props$format = props.format,
    format = _props$format === void 0 ? DEFAULT_FORMAT : _props$format,
    _props$steps = props.steps,
    steps = _props$steps === void 0 ? DEFAULT_STEPS : _props$steps,
    handleConfirmClick = props.handleConfirmClick,
    isFooterDisplay = props.isFooterDisplay,
    onChange = props.onChange,
    value = props.value,
    _props$isShowPanel = props.isShowPanel,
    isShowPanel = _props$isShowPanel === void 0 ? true : _props$isShowPanel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    triggerScroll = _useState2[0],
    toggleTriggerScroll = _useState2[1];
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var TEXT_CONFIG = useTimePickerTextConfig();
  var panelClassName = "".concat(classPrefix, "-time-picker__panel");
  var showNowTimeBtn = !!steps.filter(function (v) {
    return v > 1;
  }).length;
  var defaultValue = useMemo(function () {
    var isStepsSet = !!steps.filter(function (v) {
      return v > 1;
    }).length;
    if (value) {
      return dayjs(value, format);
    }
    if (isStepsSet) {
      return dayjs().hour(0).minute(0).second(0);
    }
    return dayjs();
  }, [value, format, steps]);
  useEffect(function () {
    if (isShowPanel) toggleTriggerScroll(true);
  }, [isShowPanel]);
  var handleOnChange = function handleOnChange(v, e) {
    var _props$onPick;
    props.onChange(v);
    (_props$onPick = props.onPick) === null || _props$onPick === void 0 ? void 0 : _props$onPick.call(props, v, {
      e: e
    });
  };
  return /* @__PURE__ */React.createElement("div", {
    className: panelClassName
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelClassName, "-section-body")
  }, /* @__PURE__ */React.createElement(SinglePanel, _objectSpread(_objectSpread({}, props), {}, {
    onChange: handleOnChange,
    format: format,
    steps: steps,
    value: value,
    triggerScroll: triggerScroll,
    isVisible: isShowPanel,
    resetTriggerScroll: function resetTriggerScroll() {
      return toggleTriggerScroll(false);
    }
  }))), isFooterDisplay ? /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelClassName, "-section-footer")
  }, /* @__PURE__ */React.createElement(Button, {
    theme: "primary",
    variant: "base",
    onClick: function onClick() {
      handleConfirmClick(defaultValue);
    },
    size: "small"
  }, TEXT_CONFIG.confirm), !showNowTimeBtn ? /* @__PURE__ */React.createElement(Button, {
    theme: "primary",
    variant: "text",
    size: "small",
    onClick: function onClick() {
      return onChange(dayjs().format(format));
    }
  }, TEXT_CONFIG.nowTime) : null) : null);
};

export { TimePickerPanel as default };
//# sourceMappingURL=TimePickerPanel.js.map
